import "intl-pluralrules";
import { initI18n } from "@memorang/helpers/i18n";

const i18n = initI18n();

export default i18n;
